module.exports = __webpack_public_path__ + "media/images/img_top_mv_point02-f4ec4ad223552920a9e24f64ed128e97.png";